import { emailRegex } from '../constants/regex';

export const isEmail = (value: string) => emailRegex.test(value);
